<template>
<v-spin :spinning="spinning" tip="上传中">
  <v-card title="EMS对账单">
     <v-modal
      title="提示信息"
      :visible="visible"
      @ok="handleOk"
     
    >
            <div v-html="message"></div>
      <!-- <p>{{ message }}</p> -->
          </v-modal
    >
    <div class="grid-demo">
      <v-form slot="form">
        <v-row :gutter="24">
          <v-col class="gutter-row" span="16">
            <div style="text-align: left">
                <v-form-item label="区域">
           <v-select
          style="width: 100px"
          :data="qy_options"
          v-model="qy"
           @change="change"
        ></v-select>
          </v-form-item>
               <v-form-item label="导入模板">
            <a href="../../../static/other/EMS对账单导入.xlsx">EMS对账单导入模板.xlsx</a>
          </v-form-item>

          <v-form-item>
            <v-upload
              :action="uploadParam.action"
              :accept="uploadParam.xml"
              multiple
              @change="uploadOnChange"
            >
              <v-button type="ghost">
                <v-icon type="upload"></v-icon>点击上传
              </v-button>
            </v-upload>
          </v-form-item>
              
            </div>
            
          </v-col>
          <!-- <v-col class="gutter-row" span="8">
            <div style="text-align: right">
              <v-form-item>
                <v-input
                  placeholder="输入存货名称"
                  v-model="cx"
                ></v-input>
              </v-form-item>
              <v-form-item>
                <v-button type="primary" icon="search" @click="findList()"
                  ><span>检索</span></v-button
                >
              </v-form-item>
            </div>
          </v-col> -->
        </v-row>
      </v-form>
    </div>
    <br />
    <vxe-grid
      v-bind="xGridOptions"
      size="mini"
      stripe
      highlight-current-row
      highlight-hover-row
      ref="xTable"
      :data="tableData"
    >
      <!--自定义插槽 cz-->
      <template v-slot:cz="{ row }">
        <span>
          <span>
            <a class="link" @click="add(row)" title="修改">
              <v-icon type="edit"></v-icon>
            </a>
            &nbsp;&nbsp;
            <v-popconfirm
              title="是否确认删除数据，删除后数据无法恢复！"
              @confirm="del(row)"
              @cancel="cancel"
              placement="bottomRight"
            >
              <a class="link" title="删除">
                <v-icon type="delete"></v-icon>
              </a>
            </v-popconfirm>
          </span>
        </span>
      </template>
      <template v-slot:empty>
        <span style="color: red">
          <p>未搜索到结果！</p>
        </span>
      </template>
    </vxe-grid>
  </v-card>
</v-spin>
</template>
<script>
let uploadParam = {
  xml: ".xlsx",
  action: "api/system/ywgl/dzd-data-upload",
}
let qy_options = [
        {
          value: "上海",
          label: "上海",
        },
        {
          value: "北京",
          label: "北京",
        },
        {
          value: "沈阳",
          label: "沈阳",
        },
        {
          value: "广州",
          label: "广州",
        },
         {
          value: "武汉",
          label: "武汉",
        },
         {
          value: "中信银行",
          label: "中信银行",
        },
      ]
export default {
  data() {
    return {
      
       spinning:false,
      message: "",
      visible: false,
      uploadParam,
      tableData: [],
      qy:"上海",qy_options,
      cx: "",
      xGridOptions: {
        showOverflow: true,
        resizable: true,
        height: 500,
        loading: false,
        headerAlign: "center",
        columns: [
          {
            type: "seq",
            title: "序号",
            width: 70,
            align: "center",
          },
           {
            field: "ywdh",
            title: "业务单号",
            align: "center",
          },
          {
            field: "uid",
            title: "用户id",
            align: "center",
          },
           {
            field: "je",
            title: "金额",
            align: "right",
            formatter:"formatNumber"
          },
           {
            field: "fkr",
            title: "付款人",
            align: "center",
          },
          {
            field: "kpzt",
            title: "开票状态",
            align: "center",
            slots: {
              default: ({ row, column }) => {
                let xy_bz = row.kpzt == '1' ? "已开具" : "未开具";
                return [<span>{xy_bz}</span>];
              },
            },
          },
          {
            field: "rq",
            title: "导入日期",
            align: "center",
          },
          {
            field: "ywrq",
            title: "业务发生日期",
            align: "center",
          },
          {
            field: "hzzt",
            title: "护照状态",
            align: "center",
          },
       
         
        ],
      },
    };
  },
  created() {
    this.uploadParam.action = "api/system/ywgl/dzd-data-upload?qy=" + this.qy
    //this.findList();
  },
  methods: {
    findList() {
      this.xGridOptions.loading = true
      this.$axios.get("api/system/ywgl/get-dzd-list?cx=" + this.cx).then((res) => {
         
        this.tableData = res.data.data;
        this.xGridOptions.loading = false
      });
    },
    
   
    uploadOnChange(info) {
      this.spinning = true
      if (info.file.response) {

        if (info.file.response == "导入成功") {
          // this.$message['success'](info.file.response);
          this.message = info.file.response;
          this.showModal();
          this.spinning = false
          this.findList();
          //debugger
          // this.$refs.child.findList()
        }
        else {
          // this.$message['error'](info.file.response);
          this.message = info.file.response;
          this.showModal();
          this.spinning = false
        }
      }
    },
    showModal() {
      this.visible = true;
    },
    handleOk() {
      this.visible = false;
      this.findList();
    },
    handleCancel() {
      this.visible = false;
    },
    change(){
       this.uploadParam.action = "api/system/ywgl/dzd-data-upload?qy=" + this.qy
    }
  },
};
</script>


<style>
</style>


// WEBPACK FOOTER //
// src/view/ywgl/dzddr.vue